module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo1-2be2522b3b9fcbcc4104faeae8daaf5a.jpg";